// src/App.js
import React, { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import styled, { keyframes } from "styled-components";

// Layouts
import MainLayout from "./layouts/MainLayout";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

// Lazy-loaded pages for better performance
const HomePage = React.lazy(() => import("./pages/HomePage"));
const ConstructionCompaniesPage = React.lazy(() =>
  import("./pages/ConstructionCompaniesPage")
);
const RealEstateAgentsPage = React.lazy(() =>
  import("./pages/RealEstateAgentsPage")
);
const FaqPage = React.lazy(() => import("./pages/FAQPage"));
const ContactPage = React.lazy(() => import("./pages/ContactPage"));
const NotFoundPage = React.lazy(() => import("./pages/NotFoundPage"));
const AboutPage = React.lazy(() => import("./pages/AboutPage"));
const ApplyPage = React.lazy(() => import("./pages/ApplyPage"));
const PrivacyPage = React.lazy(() => import("./pages/PrivacyPage"));
const TermsPage = React.lazy(() => import("./pages/TermsPage"));
const ProjectsPage = React.lazy(() => import("./pages/ProjectsPage"));
const ProjectDetailsPage = React.lazy(() =>
  import("./pages/ProjectDetailsPage")
);

// Loading spinner component
const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;

  &::after {
    content: "";
    width: 50px;
    height: 50px;
    border: 5px solid ${(props) => props.theme.colors.primary || "#3498db"};
    border-top-color: transparent;
    border-radius: 50%;
    animation: ${spin} 1s linear infinite;
  }
`;

function App() {
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<HomePage />} />
          <Route
            path="construction-companies"
            element={<ConstructionCompaniesPage />}
          />
          <Route
            path="insaat-firmalari"
            element={<ConstructionCompaniesPage />}
          />
          <Route path="agents" element={<RealEstateAgentsPage />} />
          <Route path="emlakcilar" element={<RealEstateAgentsPage />} />
          <Route path="faq" element={<FaqPage />} />
          <Route path="sss" element={<FaqPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="iletisim" element={<ContactPage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="hakkimizda" element={<AboutPage />} />
          <Route path="apply" element={<ApplyPage />} />
          <Route path="basvuru" element={<ApplyPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="kosullar" element={<TermsPage />} />
          <Route path="privacy" element={<PrivacyPage />} />
          <Route path="gizlilik" element={<PrivacyPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="projeler" element={<ProjectsPage />} />
          <Route path="project/:id" element={<ProjectDetailsPage />} />
          <Route path="proje/:id" element={<ProjectDetailsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
